import React from 'react';

export default class MarkInquiry extends React.Component {
    updateInquire(event) {
       this.props.updateApplication(event.target.name, event.target.checked);
    }

    render() {
        const { inquire, inquireNote } = this.props;

        return (
            <div>
                <p className="medium-text">Mark For Inquiry</p>
                <br />
                <div className="info-row">
                    <div className="column-third">
                        <div className="custom-check-container">
                            <input type="checkbox" id="inquire" name="inquire" className="custom-check"
                                checked={inquire}
                                onChange={this.updateInquire.bind(this)} />
                            <label htmlFor="inquire">Mark this application for inquiry</label>
                        </div>
                    </div>  
                    {inquire && (<div className="column-two-thirds">
                        <input type="text" placeholder="Enter inquiry note"
                            value={inquireNote} 
                            onChange={(e) => this.props.updateApplication('inquireNote', e.target.value)} />
                    </div>)}
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/applicationsComponents/applicationsCommon/MarkInquiry.jsx